import { FC, PropsWithChildren } from 'react'
import config from 'config'
import { PostHogProvider } from 'posthog-js/react'

export const AppAnalytics: FC<PropsWithChildren> = ({ children }) => {
  if (process.env.NODE_ENV === 'development') {
    return <>{children}</>
  }
  return (
    <PostHogProvider
      apiKey={config.NEXT_PUBLIC_POSTHOG_KEY}
      options={{
        api_host: config.NEXT_PUBLIC_POSTHOG_HOST,
        capture_pageview: false
      }}>
      {children}
    </PostHogProvider>
  )
}
